import * as React from "react";
import styles from "./styles.module.scss";
import { EventVendorQuery } from "@src/@types/api.d";
import Icon from "@src/components/Icon";
import { decodeHtmlEntities } from "@src/utils/general";

type Props = {
  eventId: number;
  eventVendorData: EventVendorQuery;
};

const Vendors: React.FC<Props> = ({ eventId, eventVendorData }) => {
  return eventVendorData?.eventVendor &&
    eventVendorData?.eventVendor.length !== 0 ? (
    <div className="px-4 bg-[linear-gradient(180deg,_#00234B_0%,_#002D60_100%)]">
      <section className="py-2">
        <h1 className="text-5xl text-center font-ntFab text-[#FCE2B0] mt-4 mb-2">
          Our Vendors
        </h1>
        <div className="border-y border-y-[#FCE2B0] mb-2 py-[5rem]">
          <div className="flex flex-wrap justify-center gap-8">
            {eventVendorData?.eventVendor?.map((vendor, index) => {
              const decodedName = decodeHtmlEntities(vendor?.name);
              const decodedRole = decodeHtmlEntities(vendor?.role);
              const decodedEmail = decodeHtmlEntities(vendor?.email);
              const decodedInstagramHandle = decodeHtmlEntities(
                vendor?.instagram_handle
              );

              return (
                <div
                  key={`vendors-home-page-${index}`}
                  className="p-4 flex flex-col justify-center items-center gap-2 lg:gap-4 w-full text-[#FCE2B0] max-w-xs vendor-card"
                >
                  <div className="font-ebGaramond text-xl font-medium">
                    {decodedName}
                  </div>
                  <p className="font-ebGaramond font-light">{decodedRole}</p>
                  <p className="font-ebGaramond font-light text-sm">
                    {decodedEmail}
                  </p>
                  <div className="flex gap-2 items-center">
                    {/* {!!vendor?.facebook && (
                      <a
                        target="_blank"
                        href={
                          vendor?.facebook.includes("@")
                            ? `https://www.facebook.com/${
                                vendor?.facebook.split("@")[1]
                              }/`
                            : `https://www.facebook.com/${vendor?.instagram_handle}/`
                        }
                        rel="noopener noreferrer"
                        className="text-[#FCE2B0]"
                      >
                        <Icon iconName="facebook" />
                      </a>
                    )}

                    {!!vendor?.twitter && (
                      <a
                        target="_blank"
                        href={
                          vendor?.twitter.includes("@")
                            ? `https://www.x.com/${
                                vendor?.twitter.split("@")[1]
                              }/`
                            : `https://www.x.com/${vendor?.twitter}/`
                        }
                        rel="noopener noreferrer"
                        className=""
                      >
                        <Icon iconName="twitter[#FCE2B0]" />
                      </a>
                    )} */}

                    {!!decodedInstagramHandle && (
                      <a
                        target="_blank"
                        href={
                          decodedInstagramHandle.includes("@")
                            ? `https://www.instagram.com/${
                                decodedInstagramHandle.split("@")[1]
                              }/`
                            : `https://www.instagram.com/${decodedInstagramHandle}/`
                        }
                        rel="noopener noreferrer"
                        className=""
                      >
                        <Icon iconName="instagramWhite" />
                      </a>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  ) : (
    <></>
  );
};

export default Vendors;
